import styled from "styled-components";

import { textFieldStyles, withInputSizeStyles } from "../../../styled";

export const Input = styled.input.attrs(({ isValid }) => ({
  "aria-invalid": !isValid
}))`
  box-sizing: border-box;
  ${textFieldStyles};
  ${withInputSizeStyles};
`;
